import { Component } from "react";
import { LabelContainer, LongLabelContainer } from "../assets/style";
import { Box } from "@mui/material";

// export default function FormLabel(props: { title: any, value: any }) {
//     const { title, value } = props
//     const inputStyle = {
//         margin: "10px",
//         marginLeft: "20px",
//         borderRadius: "6px",
//         height: "32px",
//         // maxWidth: "250px",
//         width: "50%",

//     };

//     const containerStyle = {
//         display: "flex",
//         alignItems: "center",
//         marginBottom: "10px",
//     };

//     return (
//         <div style={containerStyle}>
//             <LabelContainer style={{ marginLeft: "28px" }}>
//                 {title + ": "}
//             </LabelContainer>
//             <LabelContainer style={inputStyle}>
//                 {value}
//             </LabelContainer>
//         </div>
//     );
// }

export default function FormLabel(props: { title: any, value: any }) {
    const { title, value } = props
    const inputStyle = {
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        width: "50%",
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
    };

    const labelContainerStyle = {
        marginLeft: "28px",
        marginBottom: "10px",
    };

    return (
        <div style={containerStyle}>
            <LabelContainer style={labelContainerStyle}>
                {title + ": "}
            </LabelContainer>
            <LabelContainer style={inputStyle}>
                {value}
            </LabelContainer>
        </div>
    );
}